
import { useState, useEffect } from "react";
import { Header } from "@/components/Header";
import { supabase } from "@/integrations/supabase/client";
import ProgressSteps from "@/components/pricing/ProgressSteps";
import PricingHeader from "@/components/pricing/PricingHeader";
import PricingPlans from "@/components/pricing/PricingPlans";

const PricingPage = () => {
  const [currency, setCurrency] = useState<string>("KES");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
          const { data: profile } = await supabase
            .from('profiles')
            .select('currency, country')
            .eq('id', user.id)
            .single();
          
          if (profile) {
            // Use the user's selected currency or default based on country
            const userCurrency = profile.currency || 
              (profile.country === "Ethiopia" ? "Birr" : "KES");
            setCurrency(userCurrency);
          }
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserProfile();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white">
      <Header />
      <div className="pt-24 flex flex-col items-center justify-center p-4">
        <ProgressSteps />
        
        <div className="w-full max-w-7xl space-y-8">
          {!isLoading && <PricingHeader currency={currency} />}
          <PricingPlans currency={currency} />
        </div>
      </div>
    </div>
  );
};

export default PricingPage;
